import { SearchIcon } from "@/assets/icons/general/Search";
import { TextInput } from "@/components/ui/inputs/TextInput/TextInput";

type DropdownListBoxSearchBarProps = {
  className?: string;
  onSearchChange?: (value: string) => void;
  search?: string;
};

export const DropdownListBoxSearchBar = ({ className, onSearchChange, search }: DropdownListBoxSearchBarProps) => {
  return (
    <div
      className={`${className} flex min-w-[300px] items-center justify-between border-elevation-outline-1 border-b bg-elevation-background px-4 py-1-5`}
    >
      <TextInput
        placeholder="Search"
        variant="search"
        className="!bg-transparent"
        inputClassName="!bg-transparent"
        icon={SearchIcon}
        onChange={(e) => onSearchChange?.(e.target.value)}
        value={search}
        label=""
      />
    </div>
  );
};
